import { render, staticRenderFns } from "./TransitionFade.vue?vue&type=template&id=5ef6b2a0&scoped=true&"
import script from "./TransitionFade.vue?vue&type=script&lang=js&"
export * from "./TransitionFade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6b2a0",
  null
  
)

export default component.exports